import { Link } from "react-router";
import AcademicWiz from "../common/academicWiz"
import { all_routes } from "../../../router/all_routes";
import { AcademicCommonProps, BreadCrumb, Curriculum } from "../../../../types/dataModel";
import useFetch from "../../../../hooks/useFetch";
import { useEffect, useState } from "react";
import { API } from "../../../../common/Constants";
import { getAPIHeaders, getFormattedDateDDMMYYYY, toDateFromEpoch } from "../../../../common/Utils";
import PreLoader from "../../../../core/common/preLoader";
import { MsgBoxProps } from "../common/acadmicWizModal";
import DeleteModal from "../../../../core/modals/deleteModal";
import moment from "moment";
import { useAccess } from "../../../../hooks/accessContext";

 const breadCrums: BreadCrumb[] = [
    {
      title: "Acdemics",
      link : ""
    },
    {
      title: "Curriculum",
      link : all_routes.curriculum
    },
    {
      title: "Curriculum Courses",
      link : ""
    },
 ]
  
  
  const heading ="Curriculum List"
  const headingTag = ""
  const mainAddBtnTxt = "Add Course To Curriculum"
  
  function renderRowStartTag(prop:any) {
    return (<span className="badge bg-transparent-dark text-dark rounded-pill ms-2">
      {prop?.code}
    </span>)
  }
  
  function renderTitleTags(props: any) {
    return (
      <>
        <span className={`ms-1 badge badge-xs rounded-pill bg-${props.status === "ACTIVE"
                    ? 'success' : props.status === "UPCOMING" ? 'info' : 'primary'}`}>
          {props?.status}
        </span>
        <span className="badge bg-light rounded-pill ms-1">
          Code: {props?.code}
        </span>
        <span className="badge bg-light rounded-pill ms-1">
          Courses: {props?.items?.length}
        </span>
        <span className="badge bg-light rounded-pill ms-1">
          <i className="ti ti-calendar me-1" />
          {getFormattedDateDDMMYYYY(props?.startDate)} - {getFormattedDateDDMMYYYY(props?.endDate)}
        </span>
      </>
    )
  }

  function parseToDropDownMenu (data:any[]) {
    let menu: any[] = []

    data?.forEach((item)=>{
      if(item.status !== "INACTIVE"){
        menu.push({
          value:  item.code,
          label: item.title
        })
      }
    })
    return menu;
  }

const CurriculumWiz = () => {
    const {hasAcademicMgntDelete} = useAccess()
    const { isLoading, error, callFetch } = useFetch();
    const [curriculums, setCurriclums] = useState<any>([]);
    const [course, setCourse] = useState<any>([]);
    const [msgBoxProps, setMsgBoxProp] = useState<MsgBoxProps>()
    const [deleteItem, setDeleteItem] = useState<any>({
        course:undefined, 
        curriculum:undefined,
        message: undefined,
    })

    useEffect(() => {
        fetchCurriculum()
        fetchCourses()
    }, []);
    
    const fetchCurriculum = () => {
        callFetch(API.CURRICULUM,
          'GET',
          getAPIHeaders(),
          null,
          null
      ).then((res:any)=>{
        if(res){
            setCurriclums(res.filter((item:Curriculum) => item.status !== 'INACTIVE'))
        }
      });
    }

    const fetchCourses = () => {
        callFetch(API.COURSE_SEARCH,
          'GET',
          getAPIHeaders(),
          null,
          null
      ).then((res:any)=>{
        if(res){
            setCourse(res)
        }
      });
    }

    useEffect(() => {
      if (error) {
        if (error.response?.data) {
          setMsgBoxProp({ error: true, message: error.response?.data, success: false })
        } else {
          setMsgBoxProp({ error: true, message: "Something went wrong please try again later.", success: false })
        }
      }
    }, [error]);

    const removeCourse = (curriculumCode: string, courseCode:string) => {
      callFetch(API.CURRICULUM_COURSE,
        'DELETE',
        getAPIHeaders(),
        null,
        {
          curriculumCode: curriculumCode,
          courseCode: courseCode 
        }
    ).then(()=>{
      setMsgBoxProp({error:false, message:"Course removed successfully", success: true})
      fetchCurriculum()
    });
  }

  const saveCourse = (valPrnt:any, valChild:any) => {
      if(!valPrnt){
        setMsgBoxProp({error:true, message:"Please select a curriculum", success: false})
      } else if (!valChild){
        setMsgBoxProp({error:true, message:"Please select a course", success: false})
      } else {
        const selectedCurriculum = curriculums.find((curriculum: Curriculum) => curriculum.code === valPrnt);
        const isDuplicate = selectedCurriculum?.courses?.some((course: any) => course.code === valChild);
        
        if (isDuplicate) {
          setMsgBoxProp({
            error: true, 
            message: "This course is already added to the selected curriculum", 
            success: false
          });
          return;
        }
        
        callFetch(API.CURRICULUM_COURSE,
          'POST',
          getAPIHeaders(),
          null,
          {
            curriculumCode: valPrnt,
            courseCode: valChild
          }
        ).then(()=>{
            setMsgBoxProp({error:false, message:"Course saved successfully", success: true})
            fetchCurriculum()
        })
        .catch((error)=>{
          setMsgBoxProp({
            error:true, 
            message: error?.response?.data || "Something wenth wrong, please try again later", 
            success: false
          })
        })
      }

    }

    useEffect(() => {
      if(error){
        if(error.response?.data){
          setMsgBoxProp({message: error.response?.data, error:true})
        } else{
          setMsgBoxProp({message:'Something went wrong please try again later.', error: true})
        }
      }
  }, [error]);


  const renderRowEndTag = (prnt:any, child: any) => {
    return (
      <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
        <span className="badge badge-dark me-3">
          {child.type}
        </span>
        <div className="dropdown ms-2">
          {
            hasAcademicMgntDelete() && prnt.status !== 'INACTIVE'?
            <>
              <Link
                to="#"
                className="d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i className="ti ti-dots-vertical" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#delete_modal"
                    onClick={()=>setDeleteItem({
                        course: child.code, 
                        curriculum: prnt.code,
                        message: `Are you sure you want to remove course ${child.code} from curriculum ${prnt.code}? This action is irreversible and cannot be undone.`
                      })}
                  >
                    <i className="ti ti-trash me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </>
            :<></>
          }

        </div>
      </div>
    )
  }

  const renderStats = (props:any) => {
    return (
        <div className="d-flex align-items-center justify-content-end">
          <p className="mb-0 me-3 pe-3 border-end fs-14">
            Total Curriculums : <span className="text-dark"> {props?.length} </span>
          </p>
          <p className="mb-0 me-3 pe-3 border-end fs-14">
            Total Courses : <span className="text-dark"> {getSubItemsCount(props)} </span>
          </p>
          <p className="mb-0 fs-14">
            Active Curriculums : <span className="text-dark"> {getActiveCount(props)} </span>
          </p>
        </div>
    )
  }

  const renderTitle = (cc:Curriculum) => {
    return (
      <div className="d-flex">
      <span>
        {
          cc.status === 'ACTIVE'
          ?
          <i className="ti ti-square-rounded text-success me-2" />
          :
          cc.status === 'UPCOMING'
          ?
          <i className="ti ti-square-rounded text-info me-2" />
          :
          <i className="ti ti-square-rounded text-primary me-2" />
        }
        
      </span>
      <h5 className="fw-semibold">{cc.title}</h5>
    </div>
    )
  }
    return (
        <>
        <PreLoader showLoader={isLoading} />
        <AcademicWiz
          pageHeading="Manage Curriculum Courses"
          heading={heading}
          headingTag={headingTag}
          renderRowStartTag={renderRowStartTag}
          renderRowEndTag={renderRowEndTag}
          renderTitleTags={renderTitleTags}
          renderTitle={renderTitle}
          addButtonTxt={mainAddBtnTxt}
          data={parseToCommonProps(curriculums)}
          breadCrumbs={breadCrums}
          formHeading="Add Course to Curriculum"
          formDropDownParent={{
            dropDownItems: parseToDropDownMenu(curriculums),
            dropDownLable: "Select Curriculum",
            dropDownDefault: undefined
          }}
          formDropDownChild={{
            dropDownItems: parseToDropDownMenu(course),
            dropDownLable: "Select Course",
            dropDownDefault: undefined
          }}
          onSave={saveCourse}
          msgBoxProps={msgBoxProps} 
          renderStats={renderStats}            
          />
          <DeleteModal 
            heading="Confirm Delete"
            message={deleteItem.message}
            onDelete={()=>removeCourse(deleteItem?.curriculum, deleteItem?.course)}
          />
        </>

    )
}

function parseToCommonProps (data:Curriculum[]) {
  let acedemicProps : AcademicCommonProps[] = []
  if(acedemicProps){
    data.forEach((curriculum)=>{
        let prop:AcademicCommonProps = {
          ...curriculum,
          items:[]
        }

        curriculum?.courses?.forEach((course)=>{
          prop.items?.push({
            ...course
          })
        })

        acedemicProps.push(prop)
    })
  }
  return acedemicProps
}

function getSubItemsCount (data: AcademicCommonProps[]) {
  let cnt = 0 
  if(data){
    data.forEach((item:AcademicCommonProps)=>{
      item?.items?.forEach(()=>{
        cnt = cnt +1 
      })
    })
  }
  return cnt;
}

function getActiveCount (data: Curriculum[]) {
  let cnt = 0 
  if(data){
    data.forEach((item:Curriculum)=>{
      if(isLiveOrOngoing(item)){
        cnt = cnt + 1;
      }
    })
  }
  return cnt;
}

const isLiveOrOngoing = (cc:Curriculum) =>{
  if(cc?.startDate && cc?.endDate){
    const startDate = moment(toDateFromEpoch(cc?.startDate));
    const endDate = moment(toDateFromEpoch(cc?.endDate));
    const currentDate = moment();

    if (currentDate.isBetween(startDate, endDate, 'second', '[]')) {
       return true
    } else {
        return false
    }
  } else {
    return false
  }

}

export default CurriculumWiz